export default __webpack_public_path__ + "static/media/SFProDisplay-Black.7205509f.woff";